import ComingSoon from "app/components/common/ComingSoon";
import React from "react";

const ProfileApproval = () => {
  return <ComingSoon />;
};

export default ProfileApproval;
